<template>
  <div>
    <z-container>
      <v-subheader>Vendas</v-subheader>
      <v-row dense>
        <v-col cols="12" sm="12" md="12">
          <relatorio-de-vendas></relatorio-de-vendas>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <produtos-mais-vendidos></produtos-mais-vendidos>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <ProdutosVendidosPorFornecedor></ProdutosVendidosPorFornecedor>
        </v-col>
        <!-- <v-col cols="12" sm="6" md="6">
          <ProdutosVendidosPorLote></ProdutosVendidosPorLote>
        </v-col> -->
      </v-row>
      <!-- <v-subheader>Recebimentos</v-subheader>
        <v-layout row wrap>
          <v-flex sm4>
            <pagamentos-empresa-setores></pagamentos-empresa-setores>
          </v-flex>
        </v-layout> -->
    </z-container>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import PagamentosEmpresaSetores from "./PagamentosEmpresaSetores";
import RelatorioDeVendas from "./RelatorioDeVendas";
import ProdutosMaisVendidos from "./ProdutosMaisVendidos";
import ProdutosVendidosPorFornecedor from "./ProdutosVendidosPorFornecedor";
import ProdutosVendidosPorLote from "./ProdutosVendidosPorLote";
import queryBuilder from '@/app/helpers/QueryBuilder';

export default {
  components: {
    PagamentosEmpresaSetores,
    RelatorioDeVendas,
    ProdutosMaisVendidos,
    ProdutosVendidosPorFornecedor,
    ProdutosVendidosPorLote,
  },

  data() {
    return {
      texto: "Relatórios",
    };
  },

  async beforeMount() {
    await this.$store.dispatch("listas/fetchListas", [
      queryBuilder()
        .from("Cliente")
        .selectraw("id as value, concat(id, ' - ', razao) as text, celular")
        .orderBy("razao")
        .build(),

      queryBuilder()
        .from("Variacao")
        .select("id as value", "descricao as text")
        .orderBy("descricao")
        .build(),
        
      queryBuilder()
        .from("ProdutoGrupo")
        .select("id as value", "descricao as text")
        .orderBy("descricao")
        .build(),

      queryBuilder()
        .from("Vendedor")
        .selectraw("id as value, concat(id, ' - ', nome) as text")
        .orderBy("nome")
        .build(),

      queryBuilder()
        .from("Fornecedor")
        .selectraw("id as value, concat(id, ' - ', razao) as text")
        .orderBy("razao")
        .build(),
    ]);
  },

  mounted() {
    this.setTitulo("Relatórios");
  },

  methods: {
    ...mapMutations(["setTitulo"]),
  },
};
</script>

<style scoped></style>
